import { defineComponent as s, useCssModule as o, openBlock as r, createBlock as a, resolveDynamicComponent as n, normalizeClass as l, unref as c, withCtx as p, renderSlot as d } from "vue";
const C = /* @__PURE__ */ s({
  name: "CdrText",
  __name: "CdrText",
  props: {
    tag: {
      default: "p"
    }
  },
  setup(u) {
    const t = o();
    return (e, m) => (r(), a(n(e.tag), {
      class: l(c(t)["cdr-text"])
    }, {
      default: p(() => [d(e.$slots, "default")]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  C as default
};
